module.exports = __webpack_public_path__ + "media/images/icon/i-efficiency-d7157624941f3655a5958beba031908c.svg";